export function useRegionReady() {
  const commonStore = useCommonStore()
  const isReady = computed(() => !!commonStore.currentRegionId)

  /**
   * Ждёт, пока regionId станет валидным.
   * Если уже валиден — резолвится сразу.
   */
  const untilReady = (): Promise<void> => {
    if (isReady.value) return Promise.resolve()

    return new Promise<void>((resolve) => {
      const stop = watch(isReady, (val) => {
        if (val) {
          stop()
          resolve()
        }
      })
    })
  }

  return { isReady, untilReady }
}
